import { create } from "zustand";

const useVersionStore = create((set) => ({
  mobileVersion: "4.6.31" || "dev",
  setMobileVersion: (mobileVersion) => set({ mobileVersion }),

  serverVersion: "",
  setServerVersion: (serverVersion) => set({ serverVersion }),
}));

export default useVersionStore;
